import React from "react";
import { FormattedMessage } from "react-intl";

import CardItem from "./CardItem";

interface ITotalWeightCardProps {
  total: () => { weight: number; units: number };
  weightUnit: string;
}

function TotalWeightCard({ total, weightUnit }: ITotalWeightCardProps) {
  const totals = total();

  return (
    <CardItem>
      <p className="font-b3 text-secondary">
        <FormattedMessage id="new-request.packing-list.totalWeight" defaultMessage="Total weight" />
      </p>
      {totals?.weight && totals?.units ? (
        <>
          <p className="font-b4">
            {!Number.isInteger(totals?.weight || 0) ? (totals?.weight || 0).toFixed(2) : totals?.weight || 0}{" "}
            {weightUnit === "total_kg" || weightUnit === "total_lbs" ? weightUnit.split("_")[1] : weightUnit}
          </p>
          <p className="font-b3">{`${totals?.units || 0} Units`}</p>
        </>
      ) : (
        "-"
      )}
    </CardItem>
  );
}

export default TotalWeightCard;
